import Vue from 'vue';
import ToggleCheckbox from 'components/widgets/ToggleCheckbox.vue';
import Dropdown from 'components/Butterfly/Dropdown/Dropdown.vue';
import DropdownItem from 'components/Butterfly/Dropdown/DropdownItem.vue';
import { DefaultSegmentConfig, isSegmentValid } from './EmailDigestModal.utils';
const EmailDigestModalSection = Vue.extend({
    components: {
        ToggleCheckbox,
        Dropdown,
        DropdownItem,
    },
    props: {
        segment: { type: Object, required: true },
        schema: { type: Array, required: true },
        savedQueries: { type: Array, required: true },
        sortedSegmentsForFieldsLimited: { type: Object, required: true },
        hasNps: { type: Boolean, default: false, required: false },
        hasSentiment: { type: Boolean, default: false, required: false },
    },
    data() {
        return {
            segmentConfig: DefaultSegmentConfig,
        };
    },
    methods: {
        isSegmentValid: isSegmentValid,
        updateSegment(attrs) {
            this.$emit('update:segment', {
                ...this.segment,
                ...attrs,
            });
        },
        availableFields(segment) {
            let options = this.schema
                .filter((field) => {
                if (field.typename !== 'NUMBER') {
                    return false;
                }
                if (segment.type === 'metric') {
                    return !segment.metrics.includes(field.name);
                }
                return true;
            })
                .map((field) => field.name);
            const extraOptions = [];
            if (this.hasNps) {
                if (segment.type === 'metric') {
                    extraOptions.push('NPS');
                }
                else {
                    extraOptions.push('NPS', 'NPS Impact');
                }
            }
            if (this.hasSentiment) {
                extraOptions.push('Positive Sentiment', 'Negative Sentiment', 'Neutral Sentiment', 'Mixed Sentiment');
            }
            if (['theme', 'mostChangedThemes', 'custom'].includes(segment.type)) {
                extraOptions.push('Frequency (#)', 'Frequency (%)');
            }
            options.push(...extraOptions.filter((name) => {
                if (segment.type === 'metric') {
                    return !segment.metrics.includes(name);
                }
                return segment.metric !== name;
            }));
            // Adding a divider between extraOptions and options
            options = [...new Set(extraOptions.concat(options))];
            return options;
        },
        selectedQueries(segment) {
            return this.savedQueries.filter(sq => {
                return segment.queries.includes(sq.id);
            });
        },
    }
});
export default EmailDigestModalSection;
